import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const AdminAccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const adminKey = searchParams.get('admin');
    
    if (adminKey === 'bootminds2024') {
      // Set admin authentication
      localStorage.setItem('adminAuthenticated', 'true');
      
      // Redirect to admin panel
      navigate('/admin');
    } else {
      // Invalid key, redirect to home
      navigate('/');
    }
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Verifying admin access...</p>
      </div>
    </div>
  );
};

export default AdminAccess;
